import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";

const API_URL = process.env.REACT_APP_ENDPOINT;

const DashboardSummary = ({ selectedMonth, onSelectStatus }) => {
  const [summary, setSummary] = useState({
    belum_claim: 0,
    sudah_diajukan: 0,
    reject: 0,
    approved: 0,
  });

  // Fetch summary data dari backend
  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${API_URL}/DashboardSummary`, {
        params: {
          month: selectedMonth || moment().format("YYYY-MM"),
          userEmail: localStorage.getItem("userEmail") || "",
        },
      });
      if (res.data.status === 200 && res.data.data) {
        setSummary(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching claim summary:", error);
    }
  };

  useEffect(() => {
    fetchSummary();
    const interval = setInterval(fetchSummary, 5000); // update realtime tiap 5 detik
    return () => clearInterval(interval);
  }, [selectedMonth]);

  // Handle klik pada card footer "Lihat Detail"
  const handleClick = (status) => {
    if (onSelectStatus) {
      onSelectStatus(status);
    }
  };

  return (
    <div className="container-fluid px-4"> {/* samain padding biar sejajar */}
  <div className="row g-3 mt-2 mb-4">
    {[
      { title: "BELUM CLAIM", value: summary.belum_claim, color: "#f39c12", icon: "bi-hourglass-split", status: "Belum Claim" },
      { title: "CLAIM SUDAH DIAJUKAN", value: summary.sudah_diajukan, color: "#3498db", icon: "bi-send-check", status: "Claim sudah diajukan" },
      { title: "REJECT", value: summary.reject, color: "#e74c3c", icon: "bi-x-circle", status: "Reject" },
      { title: "APPROVED", value: summary.approved, color: "#27ae60", icon: "bi-check-circle", status: "Approved" },
      { title: "SEND MFT", value: summary.send_mft || 0, color: "#8e44ad", icon: "bi-envelope-paper", status: "Send MFT" },
    ].map((item, index) => (
      <div key={index} className="col-6 col-md-4 col-lg-2 flex-grow-1">
        <div
          className="card shadow-sm border-0 h-100 text-white"
          style={{
            backgroundColor: item.color,
            borderRadius: "10px",
            minWidth: "180px",
          }}
        >
          <div className="card-body pb-2">
            <div className="d-flex justify-content-between align-items-start">
              <h2 className="fw-bold mb-0">{item.value}</h2>
              <span className="rounded p-2">
                <i className={`bi ${item.icon} fs-5 text-white`}></i>
              </span>
            </div>
            <p className="text-uppercase fw-semibold mt-2 mb-3 small">
              {item.title}
            </p>
          </div>
          <div
            className="card-footer border-0 d-flex justify-content-between align-items-center py-2 text-white"
            style={{
              background: "rgba(255,255,255,0.1)",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              cursor: "pointer",
            }}
            onClick={() => handleClick(item.status)}
          >
            <span className="small fw-semibold">Lihat Detail</span>
            <i className="bi bi-arrow-right-short fs-5"></i>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


  );
};

export default DashboardSummary;
